module.exports = __webpack_public_path__ + "img/wander-and-win.42f8d4bd.png";